import { ACTIONS } from '../Constants';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

export const postUserFeedback = (params) => {
    const { body, pathsContext } = params;
    const fetchOptions = {
        method: 'POST',
        body
    };
    const url = `${pathsContext.serverUrl}/userfeedback`;

    return (dispatch) =>
        VerbFetch(url, fetchOptions).then((body) => {
            dispatch({
                type: ACTIONS.POST_USER_FEEDBACK_SUCCESS,
                payload: {
                    userfeedback: body
                }
            });
            return body;
        });
};

/**
 *
 * @param {Object} params
 * @param {string} actionType
 * @return {function(*)}
 * @private
 */
export const getManyUserFeedback = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.serverUrl}/userfeedback`;
    const url = buildQueryString(rest, baseUrl);
    if (rest && rest.dispatchDisabled) {
        return VerbFetch(url);
    }
    return (dispatch) =>
        VerbFetch(url).then((body) => {
            dispatch({
                type: ACTIONS.GET_MANY_USER_FEEDBACK,
                payload: {
                    userfeedback: body
                }
            });
            return body;
        });
};
